import { Box } from 'braid-design-system';
import type { FC, PropsWithChildren } from 'react';

export type Screen = 'mobile' | 'tablet' | 'desktop' | 'wide';

type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> &
  U[keyof U];

interface Breakpoints {
  mobile: boolean;
  tablet: boolean;
  desktop: boolean;
  wide: boolean;
}

type DisplayProps = {
  inline?: boolean;
} & AtLeastOne<Breakpoints>;

export const Display: FC<PropsWithChildren<DisplayProps>> = ({
  inline,
  mobile = false,
  tablet = false,
  desktop = false,
  wide,
  children,
}) => {
  const display = inline ? 'inline' : 'block';

  const isWide = wide !== undefined ? wide : desktop;

  return (
    <Box
      display={{
        mobile: mobile ? display : 'none',
        tablet: tablet ? display : 'none',
        desktop: desktop ? display : 'none',
        wide: isWide ? display : 'none',
      }}
    >
      {children}
    </Box>
  );
};
